module.exports = __webpack_public_path__ + "static/media/Q3-5.43aab3c4.jpg";